<div class="purchase-container" *ngIf="!!company" [ngClass]="{ 'purchase-container--mobile': isMobile }">
  <div [ngClass]="isMobile ? 'col-12 d-flex flex-column' : 'col-8 d-flex flex-column'">
    <span class="purchase-container__header">
      {{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.TITLE" | translate }}
    </span>
    <span class="purchase-container__subheader">
      {{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.DESCRIPTION" | translate }}
    </span>

    <div class="card">
      <div class="card__header">
        <span class="title">{{ "LABELS.IMPORTER_OF_RECORD_DETAILS" | translate }}</span>
      </div>
      <div class="card__content">
        <div class="card__content-line">
          <div class="label">{{ "LABELS.BUSINESS_ID_NUMBER" | translate }}</div>
          <div class="value">
            {{ company?.identifierQualifier | identifierQualifier | translate }} {{ company?.identifier | identifier }}
          </div>
        </div>
        <div class="card__content-line">
          <div class="label">{{ "FORM_LABEL.BUSINESS_NAME" | translate }}</div>
          <div class="value">{{ company?.businessName }}</div>
        </div>
        <div class="card__content-line">
          <div class="label">{{ "LABELS.BUSINESS_TYPE" | translate }}</div>
          <div class="value">
            {{ "BUSINESS_TYPE." + enumCompanyBusinessType[company?.businessType] | translate }}
          </div>
        </div>
        <div class="card__content-line">
          <div class="label">{{ "LABELS.BUSINESS_ADDRESS" | translate }}</div>
          <div class="value">{{ getCompanyAddressLine(company) }}</div>
        </div>
      </div>
    </div>

    <div class="card card-questionnaire" [formGroup]="formGroup">
      <div class="card__header">
        <span class="title">{{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.QUESTION_CARD_TITLE" | translate }}</span>
      </div>
      <div class="card__content">
        <div class="col-12">
          <app-control-wrapper [control]="formGroup.get('positionOfChief')" [errors]="errors" [isShowHelper]="false">
            <label for="positionOfChief" control-label>
              {{
                (displayCase === 3
                  ? "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.SIGNATORY_POSITION_LABEL"
                  : "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.POSITION_LABEL"
                ) | translate
              }}
            </label>
            <input
              type="text"
              id="positionOfChief"
              class="form-control"
              [formControl]="formGroup.get('positionOfChief')"
              [dropSpecialCharacters]="false"
              [patterns]="CUSTOM_MASK"
              [mask]="'F*'"
              [appMaskErrorTooltip]="'MASK_ERROR.ONLY_ENGLISH_DIGITS_AND_SPECIAL'"
              [maxMaskLength]="35"
              [placeholder]="'COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.POSITION_HINT' | translate"
              control-wrapper
            />
          </app-control-wrapper>
        </div>
        <div class="col-12 mt-3" *ngIf="displayCase === 2">
          <input-phone
            [fc]="formGroup.get('phoneNumber')"
            [errors]="errors.phoneNumber"
            [label]="'LABELS.MOBILE_NUMBER'"
            [id]="'phoneNumber'"
            [required]="true"
          ></input-phone>
        </div>
      </div>
    </div>

    <!-- IOR Contact Information Card (Case 3: isImporterOfRecord=false) -->
    <div class="card" *ngIf="displayCase === 3">
      <div class="card__header">
        <span class="title">{{ "COMPANY.IOR.HEADER" | translate }}</span>
        <div class="action" (click)="openIorEditSidebar()">
          <img src="assets/icons/edit_gray.svg" />
        </div>
      </div>
      <div class="card__content">
        <div class="card__content-line">
          <div class="label">{{ "LABELS.FIRST_NAME" | translate }}</div>
          <div class="value">{{ iorContactData?.firstName }}</div>
        </div>
        <div class="card__content-line">
          <div class="label">{{ "LABELS.LAST_NAME" | translate }}</div>
          <div class="value">{{ iorContactData?.lastName }}</div>
        </div>
        <div class="card__content-line">
          <div class="label">{{ "COMPANY.IOR.MOBILE_NUMBER" | translate }}</div>
          <div class="value">{{ iorContactData?.phoneNumber }}</div>
        </div>
        <div class="card__content-line">
          <div class="label">{{ "LABELS.EMAIL_ADDRESS" | translate }}</div>
          <div class="value">{{ iorContactData?.emailAddress }}</div>
        </div>
      </div>
    </div>

    <div class="card" *ngIf="displayCase === 3">
      <div class="card__content">
        <div class="custom-control custom-checkbox">
          <input type="checkbox" [formControl]="formGroup.get('sendCcEmail')" class="custom-control-input" id="sendCcEmail" />
          <label class="custom-control-label" for="sendCcEmail">
            {{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.CC_EMAIL_CHECKBOX" | translate }}
          </label>
        </div>
        <div class="helper-form-control mt-1">
          {{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.CC_EMAIL_HINT" | translate }}
        </div>
      </div>
    </div>
  </div>

  <div [ngClass]="isMobile ? 'col-12' : 'col-4 paypal-container-border'">
    <div class="paypal-container" *ngIf="isPaymentPending">
      <span class="paypal-container__title">{{ "YOUR_FILING_IS_ON_HOLD" | translate }}</span>
    </div>
    <div class="paypal-container" *ngIf="!isPaymentPending">
      <span class="paypal-container__title">{{ "LABELS.PAYMENT_BREAKDOWN" | translate }}</span>

      <div class="paypal-container__price" *ngFor="let item of pendingBills">
        <span>
          {{ item?.description | translate }}
          <span>{{ item.quantity > 1 ? " (x" + item.quantity + ")" : "" }}</span>
        </span>
        <span>{{ (item?.quantity ? item?.quantity * item?.price : item?.price) | currency }}</span>
      </div>

      <div class="paypal-container__total-price">
        <span>{{ "LABELS.TOTAL_PAYMENT" | translate }}</span>
        <span>{{ totalPrice | currency }}</span>
      </div>

      <div class="text-center mb-3">
        <button class="btn btn-primary" (click)="continue()">
          <span class="d-flex align-items-center">
            {{ isHasInstantPayment ? ("GO_TO_PAYMENT" | translate) : ("BUTTON.SEND" | translate) }}
          </span>
        </button>
      </div>

      <div class="paypal-container__notes">
        <div class="paypal-container__notes-title">
          <img src="assets/icons/warning-red.svg" />
          <span>{{ "LABELS.NOTES" | translate }}:</span>
        </div>
        <ul>
          <li class="pb-3">{{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.NOTE_NOT_EDITABLE" | translate }}</li>
          <li class="pb-3">{{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.NOTE_AFTER_PAYMENT" | translate }}</li>
          <li class="pb-3">
            {{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.AUTHORIZED_SIGNATORY_INVITE_TIP" | translate }}
            <span class="invite-link" (click)="onInviteMembers()">
              {{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.INVITE_THEM_HERE" | translate }}
            </span>
          </li>
          <li>{{ "COMPANY.DIGITAL-SIGNATURE.POA_PURCHASE.CANCELLATION_PARTIAL_REFUND_TIP" | translate }}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
